import React, { Component, PropTypes } from 'react';
import { GoogleMap, withGoogleMap, Marker, InfoWindow } from 'react-google-maps';
const google = window.google;
import R from 'ramda';

class MultiMarkerMap extends Component {

  constructor(props) {
    super(props);
    this.state = {
      googleMapsIsReady: false,
      markers: props.markers,
      zoom: props.zoom,
      bounds: props.bounds,
      centerCoordinates: props.centerCoordinates,
    };
  }

  componentWillMount() {
    // we are using google map's API and we have to wait for each api to load.
    window.initializedGoogleMap.listener(() => {
      this.setState({
        googleMapsIsReady: true,
      });
    });
  }

  componentWillReceiveProps(props) {
    this.setState({
      markers: props.markers,
      zoom: props.zoom,
      bounds: props.bounds,
      centerCoordinates: props.centerCoordinates,
    });
  }
  _handleDragEnd = () => {
    const center = [this._map.getCenter().lat(), this._map.getCenter().lng()];
    const bounds = this._map.getBounds();
    const zoomLevel = this._map.getZoom();
    this.setState({ center, bounds, zoom: zoomLevel });
    this.props.onChange(center, bounds, zoomLevel);
  }

  _handleMarkerClick = (marker, markerIndex) => {
    const markers = R.prop('markers', this.state);
    markers[markerIndex].showInfoBox = true;
    this.setState({ markers });
    this.props.openInfoBox(marker);
  }

  _handleCloseClick = (markerIndex) => {
    const markers = R.prop('markers', this.state);
    markers[markerIndex].showInfoBox = false;
    this.setState({ markers });
  }

  _renderInfoWindow(ref, marker, markerIndex) {
    let content;
    if (this.props.isForPremiumUser) {
      if (marker.companyId) {
        content = marker.companyName;
      }
      if (marker.supplierId) {
        content = marker.locationName;
      }
    } else {
      content = 'Upgrade your plan to connect';
    }
    return (
      <InfoWindow
        key={`${ref}_info_window`}
        onCloseClick={() => this._handleCloseClick(markerIndex)}
      >
        <div>{content}</div>
      </InfoWindow>
    );
  }
  handleMapMounted = (map) => {
    this._map = map;
  };
  render() {
    if (!this.state.googleMapsIsReady) {
      return (
        <div> Loading... </div>
      );
    }
    const zoom = this.state.zoom || 4;
    const propsBounds = this.state.bounds;
      /* jshint ignore:start */
    let bounds;
    if (propsBounds) {
      bounds = new window.google.maps.LatLngBounds(
        propsBounds.getSouthWest(),
        propsBounds.getNorthEast()
      );
    }
    const centerCoordinates = this.state.centerCoordinates || [-33.867486900000000000, 151.206990200000060000];
    const GoogleMapLoader = withGoogleMap(() => (
      <GoogleMap
        bounds={bounds}
        onDragEnd={this._handleDragEnd}
        defaultZoom={zoom}
        ref={this.handleMapMounted}
        onZoomChanged={this._handleDragEnd}
        defaultCenter={new window.google.maps.LatLng(centerCoordinates[0], centerCoordinates[1] - 0.05)}
      >
        {this.state.markers.map((marker, index) => {
          const ref = `marker_${index}`;
          if (marker.loc && marker.loc.coordinates) {
            return (
              <Marker
                key={ref}
                onClick={() => this._handleMarkerClick(marker, index)}
                position={new window.google.maps.LatLng(marker.loc.coordinates[1], marker.loc.coordinates[0])}
              >
                {marker.showInfoBox ? this._renderInfoWindow(ref, marker, index) : <span/>}
              </Marker>
            );
          }
        })
        }
      </GoogleMap>
    ));
    return (
      <GoogleMapLoader
        containerElement={
          <div
            style={{
              height: '100%',
              position: 'absolute',
              top: '0',
              bottom: '0',
              left: '0',
              right: '0',
            }}
          />
        }
        mapElement={<div style={{ height: `100%` }} />}
      />
    );
  }
}

MultiMarkerMap.propTypes = {
  markers: PropTypes.array,
  onChange: PropTypes.func,
  openInfoBox: PropTypes.func,
  isForPremiumUser: PropTypes.bool,
  googleMapsApi: PropTypes.object,
  zoom: PropTypes.number,
  bounds: PropTypes.object,
  centerCoordinates: PropTypes.array,
};

export default MultiMarkerMap;



// WEBPACK FOOTER //
// ./src/app/components/map-multimarkers.jsx